import classNames from 'classnames';
import React, {useCallback} from 'react';

import {GwgAccelerator} from '@udemy/career-academies';
import {Tracker} from '@udemy/event-tracking';
import {SubscriptionPlanProductType} from '@udemy/graphql';
import {useI18n} from '@udemy/i18n';
import {GrowWithGoogleBannerWrapper, SubscriptionLearnMoreEvent} from '@udemy/subscription-browse';

import styles from './grow-with-google.module.less';
import {computePlanStats} from './utils/plan-stats';

export interface GrowWithGoogleProps {
    /** Optional GWG accelerators to compute plan stats (path count). When omitted, pathCount is 0. */
    allGwgAccelerators?: GwgAccelerator[];
}

export const GrowWithGoogle = ({allGwgAccelerators}: GrowWithGoogleProps = {}) => {
    const {gettext} = useI18n();
    const planStats = React.useMemo(
        () => computePlanStats(allGwgAccelerators),
        [allGwgAccelerators],
    );

    const onLearnMoreClick = useCallback(() => {
        Tracker.publishEvent(
            new SubscriptionLearnMoreEvent(
                '',
                SubscriptionPlanProductType.Consumersubscription,
                'reimagine_career',
                [],
            ),
        );
    }, []);

    return (
        <>
            <h3 className={classNames('ud-heading-xl', styles.title)}>
                {gettext('Explore more partnership subscription offerings')}
            </h3>
            <div className="ud-container">
                <GrowWithGoogleBannerWrapper
                    learnMoreUrl="/partner/google/learn-ai/"
                    onLearnMoreClick={onLearnMoreClick}
                    planStats={planStats}
                    className={styles['grow-with-google-banner']}
                />
            </div>
        </>
    );
};
